// Lot 771 — « reviens où tu étais » : un visiteur envoyé vers la connexion / l'inscription depuis une page publique
// (lien d'événement) y revient une fois connecté (Home consomme la clé au premier rendu).
const KEY = "yalola.afterAuth";
const safe = (p) => (typeof p === "string" && /^\/(?!\/)[^\s]*$/.test(p) ? p : "");

export const rememberAfterAuth = (path) => { try { if (safe(path)) sessionStorage.setItem(KEY, path); } catch { /* noop */ } };
export const consumeAfterAuth = () => {
  try {
    const p = safe(sessionStorage.getItem(KEY));
    sessionStorage.removeItem(KEY);
    return p;
  } catch { return ""; }
};
